import {
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { TenantId } from 'src/environments/environments.types';
import { RegisterService } from '../../../services';
import { DialogResult } from '../../../types';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordDialogComponent
  implements OnInit
{
  result: DialogResult | null = null;
  private form!: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: RegisterService,
    public bsModalRef: BsModalRef<ForgotPasswordDialogComponent>
  ) {}

  close(): void {
    this.bsModalRef.hide();
  }

  get emailControl(): UntypedFormControl {
    return this.form.get('email') as UntypedFormControl;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit(): void {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.service
        .requestForgotPassword(this.emailControl.value)
        .then(() => {
          this.result = { success: true };
          this.bsModalRef.hide();
        })
        .catch(() => {
          this.result = { success: false };
          this.bsModalRef.hide();
        });
    }
  }

  get tenant(): TenantId {
    return environment.tenant;
  }
}
